// extracted by mini-css-extract-plugin
export default {"primaryColor":"#35a29f","appBackgroundColorOffWhite":"#fafbfe","panelColor":"#f9fafb"};